export default {
  "content": "<g clip-path=\"url(#icon_lightning_outlined_svg__a)\"><path d=\"M6.857 16c-.11 0-.22-.02-.32-.06a.932.932 0 01-.62-.94l.37-5.84h-3.35c-.35 0-.67-.19-.83-.5a.94.94 0 01.06-.97L7.267.4a.94.94 0 011.71.53v4.95h3.88c.35 0 .67.2.84.51.16.32.13.69-.08.98l-6 8.24c-.18.25-.46.39-.75.39h-.01zm-.07-7.78c.13 0 .25.05.34.15.09.09.14.22.13.35l-.03.62-.36 5.73 5.99-8.24h-4.35c-.26 0-.47-.2-.47-.46V.94l-5.1 7.29h3.85v-.01z\"/></g><defs><clipPath id=\"icon_lightning_outlined_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};